var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModulos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8725 0C9.1742 0.079625 9.43862 0.1876 9.68205 0.38745L16.8637 7.57085C17.0875 7.82267 17.1888 8.11073 17.2674 8.43167V8.83645C17.1519 9.41027 16.8236 9.89625 16.2647 10.1099C16.198 10.1355 15.9519 10.2191 15.9019 10.2191H15.4131L15.4143 15.5659C15.3298 16.4488 14.6585 17.1208 13.7949 17.268H10.6932C10.4736 17.1698 10.3171 17.0345 10.2886 16.779C10.2027 15.4378 10.4034 13.9535 10.2898 12.6294C10.2583 12.2621 10.0194 11.9698 9.66122 11.8755C9.37807 11.801 7.8288 11.8017 7.55807 11.889C7.27702 11.9798 7.06317 12.2194 6.99265 12.5037L6.98425 16.7449C6.95642 17.0236 6.82692 17.1593 6.58 17.268H3.4783C2.6145 17.121 1.94337 16.4489 1.85885 15.5659L1.86007 10.2191H1.3713C1.2999 10.2191 1.02095 10.1155 0.937821 10.0795C0.425771 9.8574 0.129671 9.40205 0.00594578 8.87005C0.0194208 8.7199 -0.0126042 8.54368 0.00594578 8.3979C0.0255458 8.24443 0.163096 7.91665 0.247971 7.77997C2.7181 5.23303 5.23705 2.71303 7.78312 0.2422C7.9198 0.157325 8.2474 0.0196 8.40087 0.000175037L8.8725 0Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulos);
export default __webpack_public_path__ + "static/media/modulos.0eecb6525bf7ed15d1795631927cda32.svg";
export { ForwardRef as ReactComponent };